'use strict';

const cloudinary_lookup = {
    crop: 'c_',
    format: 'f_',
    gravity: 'g_',
    height: 'h_',
    quality: 'q_',
    width: 'w_',
}

function buildCloudinaryParams(config) {
    const configOpts = [];
    for (let key in config) {
        // eslint-disable-next-line no-prototype-builtins
        if (config.hasOwnProperty(key) && cloudinary_lookup[key]) {
            configOpts.push(`${cloudinary_lookup[key]}${config[key]}`);
        }
    }
    return configOpts.join(',');
}

function process(image_url, config) {
    return image_url.replace(/(\w)\/(v\d)/, `$1/${buildCloudinaryParams(config)}/$2`)
}

export default {
    process,
}